import {
  HIDE_MODAL_MESSAGE,
  HIDE_OVERLAY,
  HOVER_SIDEBAR,
  SHOW_MODAL_MESSAGE,
  SHOW_OVERLAY,
  TOGGLE_SIDEBAR, TUTORIAL_DASHBOARD
} from './constants'

export function setTutorialShow(payload) {
  return {
    type: TUTORIAL_DASHBOARD,
    payload
  }
}

export function toggleSidebar(payload) {
  return {
    type: TOGGLE_SIDEBAR,
    payload
  }
}

export function hoverSidebar(payload) {
  return {
    type: HOVER_SIDEBAR,
    payload
  }
}

export function showModalMessage(payload) {
  return {
    type: SHOW_MODAL_MESSAGE,
    payload
  }
}

export function hideModalMessage() {
  return {
    type: HIDE_MODAL_MESSAGE
  }
}

export function showOverlay() {
  return {
    type: SHOW_OVERLAY
  }
}

export function hideOverlay() {
  return {
    type: HIDE_OVERLAY
  }
}
